import qs from 'qs';
import { client } from '@/client';

// 获取租户基本信息
export function getTenantOverview(clusterName) {
  return client.get(`/api/metrics/tenant/${clusterName}/overview`);
}

// 租户列表
export function getTenantList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/tenant/${clusterName}/list`, others);
}

// 图表信息
export function getTenantChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/tenant/${clusterName}`, others);
}

// 租户详细信息
export function getTenantDetail(params) {
  const { clusterName, tenant, ...others } = params;
  return client.get(`/api/metrics/tenant/${clusterName}/${tenant}`, others);
}

// 更新租户
export function updateTenant(params) {
  return client.post('/api/console/tenant/update-metadata', params);
}

// 删除授权
export function deletePermission(params) {
  return client.delete('/api/resource/tenant/del-admin-role', params);
}

// 获取权限下拉
export function getTenantGrands(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/resource/cluster/${clusterName}/roles`, others);
}

// 新增授权
export function addTenantGrand(params) {
  const tail = qs.stringify(params, {
    addQueryPrefix: true,
  });
  return client.put(`/api/resource/tenant/add-admin-role${tail}`, params);
}

// 新增tenant
export function createTenant(params) {
  return client.put('/api/resource/tenant/create', params);
}

// 删除租户
export function deleteTenant(params) {
  return client.delete('/api/resource/tenant/delete', params);
}
